import React from 'react';
import { AppstoreAddOutlined } from '@ant-design/icons';

const Icon = function (props) {
    return <AppstoreAddOutlined />;
}

export default Icon;